import { motion } from "framer-motion";
import { useEffect, useState, useCallback } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import InviteUserModal from "../components/InviteUserModal";
import Users from "./Users";
import Invitations from "./Invitations";
import api from "../helpers/api";

const TABS = [
  { key: "users", label: "Users" },
  { key: "invitations", label: "Invitations" },
];

const UserManagement = () => {
  document.title = "User Management | Arcmedix";

  const [activeTab, setActiveTab] = useState("users");
  const [inviteModal, setInviteModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [seatUsage, setSeatUsage] = useState(null);

  const fetchSeatUsage = useCallback(async () => {
    try {
      const stored = localStorage.getItem("authUser");
      if (!stored) return;
      const authUser = JSON.parse(stored);
      const orgId = authUser?.organizationId || authUser?.organization?.id;
      if (!orgId) return;

      const { data } = await api.get(
        `organization-approval/seats?organizationId=${orgId}`
      );
      setSeatUsage(data.response);
    } catch (error) {
      console.error("Error fetching seat usage:", error);
    }
  }, []);

  useEffect(() => {
    fetchSeatUsage();
  }, [fetchSeatUsage]);

  const handleInviteSuccess = () => {
    setRefreshKey((prev) => prev + 1);
    fetchSeatUsage();
  };

  const renderSeatBadge = () => {
    if (!seatUsage) return null;

    const { usedSeats, seatLimit } = seatUsage;
    const text =
      seatLimit && seatLimit > 0
        ? `${usedSeats ?? 0}/${seatLimit} seats`
        : `${usedSeats ?? 0} seats (unlimited)`;

    return (
      <span className="text-muted ms-2" style={{ fontSize: "0.85rem" }}>
        {text}
      </span>
    );
  };

  return (
    <div className="page-content mt-4">
      <motion.div
        className="mb-4 d-flex align-items-center justify-content-between"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="d-flex align-items-center">
          <h4 className="mb-0">User Management</h4>
          {renderSeatBadge()}
        </div>
      </motion.div>

      <Nav tabs className="nav-tabs-custom mb-3">
        {TABS.map((tab) => (
          <NavItem key={tab.key}>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({ active: activeTab === tab.key })}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      {activeTab === "users" ? (
        <Users onInvite={() => setInviteModal(true)} />
      ) : (
        <Invitations refreshKey={refreshKey} onInvite={() => setInviteModal(true)} />
      )}

      <InviteUserModal
        isOpen={inviteModal}
        toggle={() => setInviteModal(false)}
        onSuccess={handleInviteSuccess}
      />
    </div>
  );
};

export default UserManagement;
